export const environment = {
  serverUrl: 'https://api.datingsphere.com',
  serverBasePath: 'v3',
};
